import { createSlice } from '@reduxjs/toolkit';
import { addRating, fetchAverageRating, fetchRatings } from '../thunks/ratingThunk.ts';

interface Rating {
  createdAt: any;
  _id: string |null | undefined;
  userId: string;
  jobId: string;
  raterId: string;
  raterName: string;
  rating: number;
  description: string;
}

interface RatingState {
  ratings: Rating[];
  averageRating: number | null;
  totalRatings: number | null;
  loading: boolean;
  error: string | null;
}

const initialState: RatingState = {
  ratings: [],
  averageRating: null,
  totalRatings: null,
  loading: false,
  error: null,
};

const ratingsSlice = createSlice({
  name: 'ratings',
  initialState,
  reducers: {
    resetRatings: (state) => {
      state.ratings = [];
      state.averageRating = null;
      state.totalRatings = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchRatings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRatings.fulfilled, (state, action) => {
        state.loading = false;

        state.ratings = action.payload;
      })
      .addCase(fetchRatings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchAverageRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAverageRating.fulfilled, (state, action) => {
        state.loading = false;
        state.averageRating = action.payload.averageRating;
        state.totalRatings = action.payload.totalRatings;
      })
      .addCase(fetchAverageRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(addRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addRating.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings.push(action.payload);
      })
      .addCase(addRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetRatings } = ratingsSlice.actions;

export default ratingsSlice.reducer;
